import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Form, Breadcrumb, DatePicker, Button } from 'antd';
import { ConfigProvider, Table, Tag, message, AutoComplete } from 'antd';
import { apis } from '../api/index.js';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import throttle from 'lodash.throttle';
import moment from 'moment';
import TableEmpty from '../components/TableEmpty.js';
import { changeListWidth, formatFromTime, formatToTime } from '../utils';
import { calcTableHeight, showMoreSearch, setScrollTop } from '../utils';
import { formatDate, breadItem, loadingOptionsHtml } from '../utils';
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

class LogForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: true,
      i18nextLng: 'zh-CN',
      dataList: [],
      page: 1,
      pageSize: 20,
      startTime: formatDate(new Date(), dateFormat) + ' 0:0:0',
      endTime: formatDate(new Date(), dateFormat) + ' 23:59:59',
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
    };

    this.throttledDataList = throttle(newState => {
      setScrollTop();
      this.getDataList(newState);
    }, 1000);
    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(215) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
  };

  componentDidMount() {
    this.throttledDataList();
    let _this = this;
    window.addEventListener('resize', () => _this.formResize());
    this.formResize();
  }

  getDataList = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      pageNum: updatedState.page,
      pageSize: updatedState.pageSize,
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      param: updatedState.param ? decodeURIComponent(updatedState.param) : '',
    };
    apis.operationLog(post).then(result => {
      this.setState({ showLoading: false });
      if (result.code === '0') {
        this.setState({ dataList: result.data.list, total: result.data.total });
      } else {
        message.error(result.message);
        if (result.code === '1009') this.props.history.push('/login');
      }
    });
  };

  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const startTime = formatFromTime(values.date);
        const endTime = formatToTime(values.date);
        const optType = values.optType;
        const newState = {
          startTime,
          endTime,
          showLoading: true,
          param: optType || '',
        };
        this.throttledDataList(newState);
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };

  getColumns1 = () => {
    const columns = [
      { title: '操作模块', dataIndex: 'module', key: 'module', width: 120 },
      {
        title: '操作结果',
        dataIndex: 'respCode',
        key: 'respCode',
        width: 100,
        render: value => (
          <Tag color={value === 0 ? '#77c565' : '#f50'}>
            {value === 0 ? '成功' : '失败'}
          </Tag>
        ),
      },
      {
        title: '操作描述',
        dataIndex: 'description',
        key: 'description',
        width: 150,
      },
      {
        title: '操作员名称',
        dataIndex: 'userName',
        key: 'userName',
        width: 150,
      },
      { title: '操作方法', dataIndex: 'method', key: 'method', ellipsis: true },
      { title: '请求URI', dataIndex: 'uri', key: 'uri', ellipsis: true },
      { title: '请求IP', dataIndex: 'ip', key: 'ip', width: 150 },
      {
        title: '操作时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 180,
      },
    ];
    return columns;
  };

  handlePageChange = page => {
    const newState = { page };
    this.throttledDataList(newState);
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const columns1 = this.getColumns1();
    const today = formatDate(new Date(), dateFormat);

    const loadingOptions = loadingOptionsHtml(this.state.showLoading);

    const { tableHeight, moreFilter, showMoreFilter } = this.state;

    return (
      <div className="data-loading">
        <div className="form-bg">
          <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
          <div className="theme-content">
            <ConnectedHeader
              toggleCollapsed={() => changeListWidth(this)}
              login={false}
              home={true}
            />

            <div className="theme-box">
              <div className="bread-crumb">
                <Breadcrumb>
                  {breadItem(['系统管理', '操作日志管理'])}
                </Breadcrumb>
              </div>
              <div className="box" style={{ width: this.state.listWidth }}>
                <div className="data-search">
                  <Form
                    className={`ant-advanced-search-form${
                      !moreFilter && showMoreFilter ? ' notOverflow' : ''
                    }`}
                    layout="inline"
                  >
                    <div className="searchBox">
                      <div className="searchBoxContent">
                        <Form.Item label="日期" colon={false}>
                          <ConfigProvider locale={zh_CN}>
                            {getFieldDecorator('date', {
                              initialValue: [
                                moment(today, dateFormat),
                                moment(today, dateFormat),
                              ],
                            })(
                              <RangePicker
                                onChange={this.onChange}
                                style={{ width: 240 }}
                                allowClear={false}
                              />
                            )}
                          </ConfigProvider>
                        </Form.Item>
                        <Form.Item label={'操作'} colon={false}>
                          {getFieldDecorator('optType', {})(
                            <AutoComplete
                              dataSource={[
                                '新增机构',
                                '修改机构',
                                '删除机构',
                                '机构管理',
                                '新增用户',
                                '用户管理',
                              ]}
                              placeholder={'请输入'}
                              allowClear={true}
                              style={{ width: 240 }}
                              dropdownMenuStyle={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                padding: '8px',
                              }}
                              className="optLogAuto"
                            />
                          )}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="searchOptBox">
                      <Form.Item>
                        <Button
                          type="primary"
                          icon="search"
                          onClick={this.handleSearch}
                        >
                          搜索
                        </Button>
                        <Button
                          icon="redo"
                          className="form-btn-margin"
                          onClick={this.handleReset}
                        >
                          重置
                        </Button>
                      </Form.Item>
                      {showMoreFilter && (
                        <Button
                          type="link"
                          className="moreFilter"
                          onClick={() => {
                            this.setState({ moreFilter: !moreFilter });
                          }}
                          icon={moreFilter ? 'down' : 'up'}
                        >
                          {moreFilter ? '展开' : '收起'}
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    className="list-item"
                    rowKey={record => record.id}
                    columns={columns1}
                    dataSource={this.state.dataList}
                    locale={{ emptyText: <TableEmpty /> }}
                    scroll={{ x: 1200, y: tableHeight }}
                    pagination={{
                      size: 'small',
                      pageSize: this.state.pageSize,
                      showTotal: () => `共${this.state.total}条`,
                      total: this.state.total,
                      onChange: this.handlePageChange,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(LogForm));
